import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import { Element, scroller } from "react-scroll";

import { getPreloadedImage } from "../assets/js/images";
import {
  getContent,
  getRightContent,
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import {
  changeSection,
  sectionAlreadyChangedDeactivate,
  toggleReadMore,
  toggleReadMoreClosed,
  toggleSectionContentDisplay,
  toggleSectionsCanBeChanged,
} from "../store/auxiliary/ui/sections";
import ContentViewer from "./ContentViewer";
import MainSection from "./MainSection";
import Menu from "./Menu";
import SectionDescriptor from "./SectionDescriptor";
import SectionIndicator from "./SectionIndicator";
import useWindowSize from "./hooks/useWindowSize";

import content from "../assets/content/content.json";
import Content1 from "./Content1";
import Content2 from "./Content2";
import Content3 from "./Content3";
import Content4 from "./Content4";
import Content5 from "./Content5";
import Content6 from "./Content6";
import Content8 from "./Content8";
import Content9 from "./Content9";

import chairmanBackground from "../assets/images/chairman-background.png";
import ceoBackground from "../assets/images/ceo-background.png";
import chairmanImage from "../assets/images/chairman-1.jpg";
import ceoImage from "../assets/images/ceo.png";
import cfoImage from "../assets/images/cfo-4.png";
import closeIcon from "../assets/images/close_icon.svg";
import grayBackground from "../assets/images/gray-background-2.png";
import useSectionsHandler, {
  thresholdToChangeSectionInMs,
} from "./hooks/useSectionsHandler";
import VerticalRange from "./VerticalRange";
import scrollToBottomImage from "../assets/images/scroll-bottom.svg";
import DownloadCenter from "./DownloadCenter";
import Content7 from "./Content7";
import Footer from "./Footer";
import {
  getMenuItems,
  getNextSectionContentIndex,
  getPrevSectionContentIndex,
} from "../assets/content/content";
import { useRef } from "react";
import { useState } from "react";

function ContentArea(props) {
  const [returnToPreviousSection, setReturnToPreviousSection] = useState(false);

  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const dispatch = useDispatch();
  const currentSectionContent = content.sections;
  const windowWidth = useWindowSize();

  const refSection0 = useRef();
  const refSection1 = useRef();
  const refSection2 = useRef();
  const refSection3 = useRef();
  const refSection4 = useRef();
  const refSection5 = useRef();
  const refSection6 = useRef();
  const refSection7 = useRef();
  const refSection8 = useRef();
  const refSection9 = useRef();

  useEffect(() => {
    if (sections.currentSection > sections.totalSections) {
      dispatch(changeSection(0));
      scroller.scrollTo(`scroll-section-${0}`, {
        duration: 1500,
        ignoreCancelEvents: true,
        // delay: 100,
        smooth: "easeInCubic",
        containerId: "content-area__wrapper",
        // offset: 50,
      });
    }
  }, [sections.currentSection]);

  useEffect(() => {
    if (returnToPreviousSection) {
      if (sections.currentSection === 10 && refSection0.current) {
        refSection0.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 1 && refSection1.current) {
        refSection1.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 2 && refSection2.current) {
        refSection2.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 3 && refSection3.current) {
        refSection3.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 4 && refSection4.current) {
        refSection4.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 5 && refSection5.current) {
        refSection5.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 6 && refSection6.current) {
        refSection6.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 7 && refSection7.current) {
        refSection7.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 8 && refSection8.current) {
        refSection8.current.scrollIntoView();
        setReturnToPreviousSection(false);
      } else if (sections.currentSection === 9 && refSection9.current) {
        refSection9.current.scrollIntoView();
        setReturnToPreviousSection(false);
      }
    }
  }, [
    sections,
    returnToPreviousSection,
    refSection0,
    refSection1,
    refSection2,
    refSection3,
    refSection4,
    refSection5,
    refSection6,
    refSection7,
    refSection8,
    refSection9,
  ]);

  const handleScroller = (sectionNumber) => {
    console.log("helllo", sectionNumber);
  };

  useSectionsHandler(handleScroller);

  const handleReadMorePressed = () => {
    dispatch(toggleReadMore());
    setTimeout(() => {
      dispatch(toggleSectionContentDisplay(true));
    }, 500);

    setTimeout(() => {
      dispatch(toggleReadMore());
    }, 1000);
  };

  const handleReadMoreClosed = () => {
    const isInsideDownloadCenter =
      sections.currentSection === getContent().sections.length;
    dispatch(toggleReadMoreClosed());
    // dispatch(changeSection(0));
    dispatch(
      changeSection(isInsideDownloadCenter ? 0 : sections.currentSection)
    );

    // setTimeout(() => {
    dispatch(toggleSectionContentDisplay(false));
    dispatch(sectionAlreadyChangedDeactivate()); //call to avoid overlay then brightness then overlay
    setReturnToPreviousSection(true);
    // }, 100);
    // setTimeout(() => {
    //   scroller.scrollTo(
    //     `scroll-section-${
    //       isInsideDownloadCenter ? 0 : sections.currentSection
    //     }`,
    //     {
    //       duration: 1500,
    //       ignoreCancelEvents: true,
    //       // delay: 100,
    //       smooth: "easeInCubic",
    //       containerId: "content-area__wrapper",
    //       // offset: 50,
    //     }
    //   );
    // }, 100);
    // setTimeout(() => {
    dispatch(toggleReadMoreClosed());
    // }, 100);
  };

  const handleOnChangeVerticalSlider = (e) => {
    if (
      sections.canChangeSection &&
      Number(e.target.value || 0) < sections.totalSections
    ) {
      dispatch(changeSection(Number(e.target.value || 0)));
      scroller.scrollTo(`scroll-section-${e.target.value}`, {
        duration: 1500,
        ignoreCancelEvents: true,
        // delay: 100,
        smooth: "easeInCubic",
        containerId: "content-area__wrapper",
        // offset: 50,
      });
      // dispatch(toggleSectionsCanBeChanged(false));
      // setTimeout(() => {
      //   dispatch(toggleSectionsCanBeChanged(true));
      // }, thresholdToChangeSectionInMs);
    }
  };

  const handleGoToBottom = () => {
    if (sections.canChangeSection) {
      dispatch(changeSection(sections.totalSections - 1));
      scroller.scrollTo(`scroll-section-${sections.totalSections - 1}`, {
        duration: 1500,
        ignoreCancelEvents: true,
        // delay: 100,
        smooth: "easeInCubic",
        containerId: "content-area__wrapper",
        // offset: 50,
      });
    }
  };

  const handlePressPrevOrNextSection = (menuIndex) => {
    dispatch(changeSection(menuIndex));
    // dispatch(toggleMenu());
    dispatch(toggleSectionContentDisplay(true));
  };

  return (
    <div style={{ position: "relative" }}>
      <div
        className={`menu-open${setAdditionalClasses(
          ["active", "draw"],
          [
            generalSettings.menuOpen,
            !generalSettings.menuOpen && generalSettings.menuPressedAtLeastOnce,
          ]
        )}`}
      >
        <Menu
          menuItems={getRightContent(generalSettings.rtlLanguage, [
            [
              "2021 At A Glance",
              "Our Strategic Milestones",
              "Chairman's Message",
              "CEO’s Message",
              "CFO’s Review",
              "Our Business Model",
              "Our Strategy",
              "Business Review",
              "Sustainability",
            ],
            [
              "المعلومات الرئيسية",
              "الأحداث الاستراتيجية الرئيسية",
              "كلمة رئيس مجلس الإدارة",
              "كلمة الرئيس التنفيذي",
              "كلمة الرئيس المالي",
              "النموذج التشغيلي",
              "استراتيجيتنا",
              "استعراض الأعمال",
              "الاستدامة",
            ],
          ])}
        />
      </div>
      <div id="content-area" className="content-area">
        <div
          className={`section-indicator__wrapper${setAdditionalClasses(
            ["hide"],
            [sections.displayContent || generalSettings.menuOpen]
          )}`}
        >
          {/* <SectionIndicator
            numberOfSections={sections.totalSections}
            currentSection={sections.currentSection}
            height={200}
          /> */}
          <VerticalRange
            value={sections.currentSection}
            min={0}
            max={9}
            handleOnChange={handleOnChangeVerticalSlider}
          />
        </div>

        <div
          className={`go-to-bottom${setAdditionalClasses(
            ["hide"],
            [
              sections.displayContent ||
                generalSettings.menuOpen ||
                windowWidth > 1023,
            ]
          )}`}
          onClick={handleGoToBottom}
        >
          <img
            src={scrollToBottomImage}
            alt=""
            className={`go-to-bottom__image${setAdditionalClasses(
              ["opacity-0"],
              [sections.currentSection === sections.totalSections - 1]
            )}`}
          />
        </div>

        <div
          id="content-area__wrapper"
          className={`content-area__wrapper${setAdditionalClasses(
            ["display-content"],
            [sections.displayContent]
          )}`}
        >
          {!sections.displayContent && (
            <>
              {/* <div
                id="section-0"
                style={{
                  backgroundColor: "orange",
                }}
                className="content-area__main-content"
              > */}
              <div ref={refSection0}>
                <Element name="scroll-section-0">
                  <MainSection
                    images={getPreloadedImage(0)}
                    sectionId={`section-0`}
                    SectionContent={
                      <SectionDescriptor
                        displayScrollIndicator={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[0].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[0].title
                        )}
                        currentSection={sections.currentSection}
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection1}>
                <Element name="scroll-section-1">
                  <MainSection
                    images={getPreloadedImage(1)}
                    sectionId={`section-1`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[1].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[1].title
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection2}>
                <Element name="scroll-section-2">
                  <MainSection
                    images={getPreloadedImage(2)}
                    sectionId={`section-2`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[2].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[2].title
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection3}>
                <Element name="scroll-section-3">
                  <MainSection
                    images={getPreloadedImage(3)}
                    sectionId={`section-3`}
                    avoidOverlay={true}
                    SectionContent={
                      <>
                        <VisibilitySensor partialVisibility>
                          {({ isVisible }) => (
                            <div
                              className="main-section__moving-background"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                `${
                                  windowWidth < 1024
                                    ? "moving-background-small-screen"
                                    : "moving-background"
                                } 2.8s 0.6s backwards ease-out`
                              )}
                            >
                              <img
                                src={chairmanBackground}
                                alt=""
                                className="main-section__moving-background-image"
                              />
                            </div>
                          )}
                        </VisibilitySensor>
                        <SectionDescriptor
                          applyImageClassName={"smaller-height"}
                          pearson={{
                            name: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[3].pearsonImage.name
                            ),
                            position: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[3].pearsonImage.position
                            ),
                          }}
                          whiteBackgroundColor={true}
                          displayReadMore={true}
                          topSubTitle={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[3].topSubtitle
                          )}
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[3].title
                          )}
                          handleReadMorePressed={handleReadMorePressed}
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[3].text
                          )}
                          image={chairmanImage}
                        />
                      </>
                    }
                  />
                </Element>
              </div>
              <div ref={refSection4}>
                <Element name="scroll-section-4">
                  <MainSection
                    images={getPreloadedImage(4)}
                    sectionId={`section-4`}
                    avoidOverlay={true}
                    SectionContent={
                      <>
                        <VisibilitySensor partialVisibility>
                          {({ isVisible }) => (
                            <>
                              <div
                                className="main-section__moving-background"
                                style={getVisibleSensorAnimation(
                                  isVisible,
                                  `${
                                    windowWidth < 1024
                                      ? "moving-background-small-screen"
                                      : "moving-background"
                                  } 2.8s 0.6s backwards ease-out`
                                )}
                              >
                                <img
                                  src={chairmanBackground}
                                  alt=""
                                  className="main-section__moving-background-image"
                                />
                              </div>
                              <div
                                className="main-section__moving-background small-width"
                                style={getVisibleSensorAnimation(
                                  isVisible,
                                  `${
                                    windowWidth < 1024
                                      ? "moving-background-small-screen"
                                      : "moving-background"
                                  } 2.2s 1s backwards ease-in-out`
                                )}
                              >
                                <img
                                  src={ceoBackground}
                                  alt=""
                                  className="main-section__moving-background-image"
                                />
                              </div>
                            </>
                          )}
                        </VisibilitySensor>

                        <SectionDescriptor
                          largerImage={true}
                          pearson={{
                            name: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[4].pearsonImage.name
                            ),
                            position: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[4].pearsonImage.position
                            ),
                          }}
                          whiteBackgroundColor={true}
                          displayReadMore={true}
                          topSubTitle={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[4].topSubtitle
                          )}
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[4].title
                          )}
                          handleReadMorePressed={handleReadMorePressed}
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[4].text
                          )}
                          image={ceoImage}
                        />
                      </>
                    }
                  />
                </Element>
              </div>
              <div ref={refSection5}>
                <Element name="scroll-section-5">
                  <MainSection
                    images={getPreloadedImage(5)}
                    sectionId={`section-5`}
                    avoidOverlay={true}
                    SectionContent={
                      <>
                        <VisibilitySensor partialVisibility>
                          {({ isVisible }) => (
                            <>
                              <div
                                className="main-section__moving-background"
                                style={getVisibleSensorAnimation(
                                  isVisible,
                                  `${
                                    windowWidth < 1024
                                      ? "moving-background-small-screen"
                                      : "moving-background"
                                  } 2.8s 0.6s backwards ease-out`
                                )}
                              >
                                <img
                                  src={chairmanBackground}
                                  alt=""
                                  className="main-section__moving-background-image"
                                />
                              </div>
                              <div
                                className="main-section__moving-background small-width"
                                style={getVisibleSensorAnimation(
                                  isVisible,
                                  `${
                                    windowWidth < 1024
                                      ? "moving-background-small-screen"
                                      : "moving-background"
                                  } 2.2s 1s backwards ease-in-out`
                                )}
                              >
                                <img
                                  src={grayBackground}
                                  alt=""
                                  className="main-section__moving-background-image"
                                />
                              </div>
                            </>
                          )}
                        </VisibilitySensor>

                        <SectionDescriptor
                          largerImage={true}
                          pearson={{
                            name: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[5].pearsonImage.name
                            ),
                            position: getRightContent(
                              generalSettings.rtlLanguage,
                              currentSectionContent[5].pearsonImage.position
                            ),
                          }}
                          whiteBackgroundColor={true}
                          displayReadMore={true}
                          topSubTitle={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[5].topSubtitle
                          )}
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[5].title
                          )}
                          handleReadMorePressed={handleReadMorePressed}
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            currentSectionContent[5].text
                          )}
                          image={cfoImage}
                        />
                      </>
                    }
                  />
                </Element>
              </div>
              <div ref={refSection6}>
                <Element name="scroll-section-6">
                  <MainSection
                    images={getPreloadedImage(6)}
                    sectionId={`section-6`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[6].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[6].title
                        )}
                        text={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[6].text
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                        applyTextClassname="color-white"
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection7}>
                <Element name="scroll-section-7">
                  <MainSection
                    images={getPreloadedImage(7)}
                    sectionId={`section-7`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[7].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[7].title
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                        applyTextClassname="color-white"
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection8}>
                <Element name="scroll-section-8">
                  <MainSection
                    images={getPreloadedImage(8)}
                    sectionId={`section-8`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[8].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[8].title
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                        applyTextClassname="color-white"
                      />
                    }
                  />
                </Element>
              </div>
              <div ref={refSection9}>
                <Element name="scroll-section-9">
                  <MainSection
                    images={getPreloadedImage(9)}
                    sectionId={`section-9`}
                    SectionContent={
                      <SectionDescriptor
                        displayReadMore={true}
                        topSubTitle={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[9].topSubtitle
                        )}
                        title={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[9].title
                        )}
                        text={getRightContent(
                          generalSettings.rtlLanguage,
                          currentSectionContent[9].text
                        )}
                        handleReadMorePressed={handleReadMorePressed}
                        applyTextClassname="color-white"
                      />
                    }
                  />
                </Element>
              </div>
            </>
          )}

          {sections.displayContent && (
            <div style={{ height: "100%", width: "100%" }}>
              <ContentViewer
                Content={
                  <div>
                    <img
                      src={closeIcon}
                      alt=""
                      className={`close-icon${setAdditionalClasses(
                        ["hide"],
                        [generalSettings.menuOpen]
                      )}`}
                      onClick={handleReadMoreClosed}
                    />
                    {[
                      null,
                      Content1,
                      Content2,
                      Content3,
                      Content4,
                      Content5,
                      Content6,
                      Content7,
                      Content8,
                      Content9,
                      () => <DownloadCenter companyName={"tanmiah"} />,
                    ].map(
                      (Content, index) =>
                        sections.currentSection === index &&
                        index !== 0 &&
                        sections.displayContent && <Content key={index} />
                    )}
                    {sections.currentSection !== 10 &&
                      sections.currentSection !== 0 && (
                        <Footer
                          onPressNextSection={() =>
                            handlePressPrevOrNextSection(
                              getNextSectionContentIndex(
                                sections.currentSection,
                                sections.list.length
                              )
                            )
                          }
                          onPressPrevSection={() =>
                            handlePressPrevOrNextSection(
                              getPrevSectionContentIndex(
                                sections.currentSection,
                                sections.list.length
                              )
                            )
                          }
                          prevContentTitle={getRightContent(
                            generalSettings.rtlLanguage,
                            getMenuItems()[
                              getPrevSectionContentIndex(
                                sections.currentSection,
                                sections.list.length
                              )
                            ].label
                          )}
                          nextContentTitle={getRightContent(
                            generalSettings.rtlLanguage,
                            getMenuItems()[
                              getNextSectionContentIndex(
                                sections.currentSection,
                                sections.list.length
                              )
                            ].label
                          )}
                        />
                      )}
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContentArea;
